export default (parentElement = document, elements = "all", directChildren = false, closestSelector = "") => {
  let focusableElements = parentElement.querySelectorAll(
    "button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])"
  );
  if (directChildren === true && closestSelector !== "") {
    focusableElements = [...focusableElements].filter(
      (element) => element.closest(closestSelector) === parentElement
    );
  }
  if (!focusableElements)
    new Error(`No focusable elements found for ${parentElement}`);
  if (elements === "first") {
    return [...focusableElements].at(0);
  }
  if (elements === "last") {
    return [...focusableElements].at(-1);
  }
  return focusableElements;
};
